import { FetchHandler } from '../../helper/fetchhandler';

export class CampaignAbandonmentComponent {

    constructor() {
        this.isDebug = false;
        this.isLeft = false;

        this.init();
    }

    /**
     * Send the deal information to backend
     */
    handleLeave() {
        if (this.isLeft) {
            return;
        }

        if (this.isDebug) {
            console.log('now leave');
        }

        if (!this.isDebug) {
            this.isLeft = true;
        }

        const paramObj = {
            _token: $('meta[name="csrf-token"]').attr('content'),
            deal_id: $('meta[name="deal-id"]').attr('content'),
        };

        FetchHandler
            .create()
            .setUrl(route('campaign-abandonment.browser'))
            .setMethod('POST')
            .setXMLHttpRequest()
            .setContentType('application/json')
            .setBody(paramObj)
            .send()
            .then((response) => {
                if (this.isDebug) {
                    console.log(response);
                }
            })
            .catch((response) => {
                if (this.isDebug) {
                    console.log(response);
                }
            });
    }

    init() {
        this.isDebug = $('meta[name="is-debug"]').attr('content');

        if (this.isDebug) {
            console.log('initBrowserLeaveListener');
        }

        let timeout = $('meta[name="abandonment-timeout"]').attr('content');

        if (this.isDebug) {
            console.log(`timeout: ${timeout}`);
        }

        setTimeout(() => {
            if (this.isDebug) {
                console.log('timer fired');
            }

            this.handleLeave();
        }, timeout);
    }
}
